import type { FC } from 'react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import type { Company } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { CompanyLoggedout } from '../../components/company-loggedout';
import {
  LOGGED_IN_CARDS_PER_PAGE,
  LOGGED_OUT_CARDS_PER_PAGE,
} from '../../config';
import { useMostVisitedCompanies } from '../../hooks/use-most-visited-companies';
import { usePagination } from '../../hooks/use-pagination';
import { scrollToTop } from '../../utils';

export const LIMostVisitedCompanies: FC = () => {
  const intl = useIntl();
  const { changePage, activePage } = usePagination();
  const { isLoggedIn } = useLoginState();
  useEffect(() => scrollToTop(), []);

  const limit = isLoggedIn
    ? LOGGED_IN_CARDS_PER_PAGE
    : LOGGED_OUT_CARDS_PER_PAGE;

  const { data, loading, error } = useMostVisitedCompanies({
    limit,
    offset: limit * (activePage - 1),
  });

  const { collection, total } = data?.mostVisitedCompanies ?? {};

  return (
    <CompanyLoggedout
      companies={collection?.map((item) => item?.company as Company)}
      total={total}
      headerText={intl.formatMessage({ id: 'CP_100_MOST_CLICKED_COMPANIES' })}
      authenticated={isLoggedIn}
      limit={limit}
      activePage={activePage}
      changePage={changePage}
      loading={loading}
      error={error}
      companyType="most-visited"
    />
  );
};
